import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { PelicanLogo } from '../components/PelicanLogo';
import { toast } from 'sonner';

export const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const result = await login(email, password);
    if (result.success) {
      toast.success('Login successful!');
      navigate('/');
    } else {
      toast.error(result.error);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex">
      <div className="flex-1 flex items-center justify-center px-4 sm:px-6 lg:px-8 bg-background">
        <div className="max-w-md w-full space-y-8">
          <div className="text-center">
            <Link to="/" className="inline-flex items-center gap-2 mb-6">
              <PelicanLogo className="h-12 w-12 text-primary" strokeWidth={1.5} />
              <span className="text-3xl font-semibold tracking-tight">ArdNotes</span>
            </Link>
            <h2 className="mt-6 text-3xl font-semibold tracking-tight text-main">Admin sign in</h2>
            <p className="mt-2 text-sm text-foreground/70">Restricted to platform moderators.</p>
          </div>

          <form className="mt-8 space-y-6" onSubmit={handleSubmit} data-testid="login-form">
            <div className="space-y-4">
              <div>
                <Label htmlFor="email">Email address</Label>
                <Input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="mt-1"
                  data-testid="login-email-input"
                />
              </div>
              <div>
                <Label htmlFor="password">Password</Label>
                <Input
                  id="password"
                  name="password"
                  type="password"
                  autoComplete="current-password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="mt-1"
                  data-testid="login-password-input"
                />
              </div>
            </div>

            <Button
              type="submit"
              className="w-full"
              disabled={loading}
              data-testid="login-submit-button"
            >
              {loading ? 'Signing in...' : 'Sign in'}
            </Button>

            <p className="text-center text-xs text-foreground/55">
              <Link to="/" className="hover:text-primary" data-testid="login-back-link">
                ← Back to ArdNotes
              </Link>
            </p>
          </form>
        </div>
      </div>

      <div className="hidden lg:flex flex-1 relative items-center justify-center bg-gradient-to-br from-emerald-50 to-white dark:from-slate-900 dark:to-slate-950 border-l border-border">
        <div className="text-center p-12 max-w-md">
          <PelicanLogo className="h-32 w-32 text-primary mx-auto mb-8 opacity-80" strokeWidth={1.5} />
          <h3 className="text-3xl font-semibold tracking-tight mb-4">Welcome back to ArdNotes</h3>
          <p className="text-foreground/70 leading-relaxed">
            Knowledge that lasts beyond exams. Pick up where you left off and keep building your academic legacy.
          </p>
        </div>
      </div>
    </div>
  );
};